import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap font-bold select-none cursor-pointer border transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        primary: 'bg-primary-btn-bg text-primary-btn-fg border-transparent hover:opacity-90',
        timer: 'bg-timer-btn-bg text-timer-btn-fg border-transparent hover:opacity-90 font-extrabold',
        secondary: 'bg-card text-ink border-border hover:bg-inset',
        ghost: 'bg-transparent text-ink-2 border-transparent hover:text-ink hover:bg-inset',
        danger: 'bg-danger-fg text-on-danger border-transparent hover:opacity-90',
      },
      size: {
        sm: 'h-[30px] px-3 text-[12.5px] rounded-input',
        md: 'h-9 px-4 text-row-title rounded-btn',
        lg: 'h-11 px-7 text-[15px] rounded-pill',
        icon: 'h-10 w-10 rounded-full p-0',
        dialog: 'h-10 px-5 rounded-[20px] text-[13.5px]',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);
